import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Mic } from "lucide-react";
import { NAV } from "@/constants/testIds";
import InstallPWAButton from "@/components/InstallPWAButton";
import NotificationBell from "@/components/NotificationBell";

/** 5 taps on the logo within 3s opens the admin login — hidden easter egg. */
const useSecretAdmin = () => {
  const navigate = useNavigate();
  const taps = useRef([]);
  return () => {
    const now = Date.now();
    taps.current = [...taps.current.filter((t) => now - t < 3000), now];
    if (taps.current.length >= 5) {
      taps.current = [];
      navigate("/admin/login");
    }
  };
};

const Header = () => {
  const onSecret = useSecretAdmin();
  return (
    <header
      className="sticky top-0 z-40 border-b border-white/5"
      style={{
        background: "var(--fi-blue)",
        paddingTop: "env(safe-area-inset-top, 0px)",
      }}
    >
      <div className="max-w-6xl mx-auto flex items-center justify-center sm:justify-between px-4 md:px-6 py-3 relative">
        {/* Logo — centered on mobile, left-aligned on desktop. Enlarged tap target. */}
        <button
          type="button"
          onClick={onSecret}
          data-testid={NAV.logo}
          aria-label="Fala Itapira"
          className="flex items-center gap-3 select-none outline-none focus:outline-none rounded-2xl px-3 py-2 -mx-3 -my-2 min-w-[210px] sm:min-w-0 hover:bg-white/5 active:bg-white/10 transition-colors"
          style={{ WebkitTapHighlightColor: "transparent", touchAction: "manipulation" }}
        >
          <div className="relative flex items-center justify-center w-11 h-11 sm:w-10 sm:h-10 rounded-xl fi-gradient">
            <div className="absolute inset-[3px] rounded-[10px] flex items-center justify-center" style={{ background: "var(--fi-blue)" }}>
              <Mic className="w-5 h-5 text-white" strokeWidth={2.4} />
            </div>
          </div>
          <div className="leading-none text-left">
            <div className="font-display text-white text-2xl md:text-3xl font-extrabold uppercase tracking-tight">
              Fala Itapira
            </div>
            <div className="text-[10px] md:text-xs font-medium tracking-[0.28em] uppercase text-white/60 mt-0.5">
              e Região
            </div>
          </div>
        </button>

        {/* Right cluster — bell always visible; install button only on desktop */}
        <div className="flex items-center gap-3 absolute right-4 md:right-6 top-1/2 -translate-y-1/2">
          <div className="hidden sm:block">
            <InstallPWAButton />
          </div>
          <NotificationBell />
          <div className="hidden md:flex items-center gap-2 text-white/80 text-xs uppercase tracking-widest font-semibold">
            <span className="w-2 h-2 rounded-full bg-[var(--fi-red)] live-dot" />
            No ar agora
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
